import { IConfiguration } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class ConfigurationService extends AxiosService {
  private static instance: ConfigurationService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): ConfigurationService {
    if (!ConfigurationService.instance) {
      ConfigurationService.instance = new ConfigurationService();
    }
    return ConfigurationService.instance;
  }

  public async findOneConfig(term: string): Promise<any> {
    try {
      const url: string = 'configuration';
      const response: IConfiguration = await this.axios.post(url, { term });
      return Promise.resolve(response.metaData);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default ConfigurationService.getInstance;
